import { render, staticRenderFns } from "./MapPolygons.vue?vue&type=template&id=57c99dc2&scoped=true&"
import script from "./MapPolygons.vue?vue&type=script&lang=js&"
export * from "./MapPolygons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c99dc2",
  null
  
)

export default component.exports